var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SectionTitle',{attrs:{"label":_vm.$t('label.termsOfService'),"text-class":"primary--text text--darken-1"}}),_c('div',{staticClass:"scrollable-text-section",domProps:{"innerHTML":_vm._s(_vm.agentTermsAndConditions)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }